const isArray = value => {
  return value && value.constructor === Array;
};
var isArray$1 = isArray;

export { isArray$1 as i };
